import interiorDesign from "../../../assets/images/urban/interior-design.jpg";
import decoration from "../../../assets/images/urban/decoration.PNG";
import customFurniture from "../../../assets/images/urban/custom-furniture.png";
import systemFurniture from "../../../assets/images/urban/system-furniture.jpg";
import img06 from "../../../assets/images/urban/img-06.jpg";
import img07 from "../../../assets/images/urban/img-07.jpg";
import paths from "../../../routes/paths";

import pioneer1 from "../../../assets/images/urban/pionner-1.jpg";
import innocity1 from "../../../assets/images/urban/innocity-1.jpg";
import alpha1 from "../../../assets/images/urban/alpha-1.jpg";
import ige1 from "../../../assets/images/urban/ige-1.jpg";
import inya1 from "../../../assets/images/urban/inya-1.jpg";
import cityCare from "../../../assets/images/urban/city-care.JPG";
import yoma from "../../../assets/images/urban/yoma.JPG";
import sumitomo from "../../../assets/images/urban/sumitomo.JPG";
import cityviall from "../../../assets/images/urban/city-villa.jpg";
import innocity from "../../../assets/images/urban/innocity.jpg";
import kabaraye from "../../../assets/images/urban/kabaraye-mayangone.png";
import primrose from "../../../assets/images/urban/primrose.jpg";
import bahan from "../../../assets/images/urban/bahan-residence.jpg";
import paramiValley from "../../../assets/images/urban/parami-valley.jpg";
export const servicesData = {
  title: "Services We Do",
  id: "services",
  data: [
    {
      title: "Interior Design",
      description:
        "Create stunning, functional spaces with our expert design services.",
      imgUrl: interiorDesign,
    },
    {
      title: "Interior Decoration",
      description:
        "Enhance your environment with our tailored decoration solutions.",
      imgUrl: decoration,
    },

    {
      title: "Custom Furniture",
      description:
        "Get unique, handcrafted furniture designed specifically for your needs.",
      imgUrl: customFurniture,
    },

    {
      title: "Office Furniture",
      description:
        "Optimize your space with our versatile and practical system furniture options.",
      imgUrl: systemFurniture,
    },
  ],
};

export const projectsData = {
  title: "PROJECTS",
  id: "projects",
  data: [
    {
      title: "Commmercial & Retail",
      // description: "We design Wardrobes,Kitchen Cabinets based blah",
      imgUrl: pioneer1,
      link: paths.projects1,
      id: "commercial",
    },
    // {
    //   title: "Condominium",
    //   // description: "We design Wardrobes,Kitchen Cabinets based blah",
    //   imgUrl: innocity1,
    //   link: paths.projects2,
    // },

    {
      title: "Office",
      // description: "We design Wardrobes,Kitchen Cabinets based blah",
      imgUrl: alpha1,
      link: paths.projects3,
      id: "office",
    },

    {
      title: "Residence",
      // description: "We design Wardrobes,Kitchen Cabinets based blah",
      imgUrl: inya1,
      link: paths.projects4,
      id: "residence",
    },
  ],
};
const rawCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fraw%2F2.png?alt=media&token=96dd3b82-a4c7-49e4-9341-777945093e8f";

const rebornCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Freborn%2F2.jpg?alt=media&token=8006d8c0-7da1-44ce-9038-ac0cf27ef5e5";

const sakuraCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fsakura%2F1.JPG?alt=media&token=c26701ae-c71c-4e23-9069-f7977cfe4a01";
const cllCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fcll%2FIMG_0794.JPG?alt=media&token=3621ad9d-f703-4888-9670-e7b964f93cae";
const fitbaeCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Ffitbae%2Ffit-2.jpg?alt=media&token=7e71e1d6-0b7b-4a58-a1ce-5fab64116876";

const pioneerCover =
  "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fpioneer%2F1.jpg?alt=media&token=410e7e53-7406-4189-9786-35a3bf9442f4";
export const projects = [
  {
    title: "Commercial & Retail",
    projects: [
      {
        title: "Pioneer DJ",
        images: [pioneerCover],
        keyword: "pioneer",
      },
      {
        title: "RAW Coffee Lounge",
        images: [rawCover],
        keyword: "raw",
      },
      {
        title: "re : born K-beauty and skin care",
        images: [rebornCover],
        keyword: "reborn",
      },
      {
        title: "Sakura Hospital",
        images: [sakuraCover],
        keyword: "sakura",
      },
      {
        title: "City Care",
        images: [cityCare],
        keyword: "city-care",
      },
      {
        title: "CLL",
        images: [cllCover],
        keyword: "cll",
      },
      {
        title: "Fitbae",
        images: [fitbaeCover],
        keyword: "fitbae",
      },
    ],
  },
  {
    title: "Condominium",
    projects: [
      {
        title: "Innocity Room 1103",
        images: [innocity1],
      },
    ],
  },
  {
    title: "Office",
    projects: [
      {
        title: "Yoma Land",
        images: [yoma],
        keyword: "yoma",
      },
      {
        title: "Alpha International",
        images: [alpha1],
        keyword: "alpha",
      },
      {
        title: "IGE",
        images: [ige1],
        keyword: "ige",
      },
      {
        title: "Sumitomo Corporation",
        images: [sumitomo],
        keyword: "sumitomo",
      },
    ],
  },
  {
    title: "Residence",
    projects: [
      {
        title: "InyaMyaing, Bahan",
        images: [inya1],
        keyword: "inyamyaing",
      },
      {
        title: "196 City Villa - Star City Thanlyin",
        images: [cityviall],
        keyword: "city-villa",
      },
      {
        title: "Kabaraye , Mayangone",
        images: [kabaraye],
        keyword: "kabaraye-mayangone",
      },
      {
        title: "Primrose Condo , 8 miles",
        images: [primrose],
        keyword: "primrose",
      },
      {
        title: "Innocity , South Oakkalapa",
        images: [innocity],
        keyword: "innocity",
      },
      {
        title: "Bahan Residence",
        images: [bahan],
        keyword: "bahan",
      },
      {
        title: "Parami Valley Residence",
        images: [paramiValley],
        keyword: "parami",
      },
    ],
  },
];

export const navlinksData = [
  {
    label: "About Us",
    href: "#about-us",
  },
  {
    label: "Services",
    href: "#services",
  },
  // {
  //   label: "Shop",
  //   href: "#",
  //   // sublinks: [
  //   //   {
  //   //     label: "sublink one ",
  //   //     href: "#",
  //   //   },
  //   //   {
  //   //     label: "sublink two ",
  //   //     href: "#",
  //   //   },
  //   // ],
  // },
  {
    label: "Projects",
    href: "#",
    sublinks: [
      {
        label: "Commercial & Retail",
        href: "/projects-1",
      },
      {
        label: "Office",
        href: "/projects-3",
      },
      {
        label: "Residence",
        href: "/projects-4",
      },
      // {
      //   label: "System Furniture",
      //   href: "#services",
      // },
    ],
  },
  {
    label: "Shop",
    href: "https://shop.urbanfurnituregroup.com",
  },
  {
    label: "Contact Us",
    href: "#footer",
  },
];

export const officeFurnitureData = {
  title: "Office Furniture",
  id: "office-furniture",
  data: [
    {
      id: 1,
      name: "Movement Bra",
      cate: "34,000 MMK",
      img: interiorDesign,
    },
    {
      id: 2,
      name: "Kardio bra",
      cate: "34,000 MMK",
      img: decoration,
    },
    {
      id: 3,
      name: "Halter Bra",
      cate: "34,000 MMK",
      img: customFurniture,
    },
    {
      id: 4,
      name: "Movement Bra",
      cate: "34,000 MMK",
      img: systemFurniture,
    },
    {
      id: 5,
      name: "Enhance bra",
      cate: "34,000 MMK",
      img: img06,
    },
    {
      id: 6,
      name: "Ace Sports Bra",
      cate: "34,000 MMK",
      img: img07,
    },
  ],
};

export const livingFurnitureData = {
  title: "Living Furniture",
  id: "living-furniture",
  data: [
    {
      id: 1,
      name: "Movement Bra",
      cate: "34,000 MMK",
      img: interiorDesign,
    },
    {
      id: 2,
      name: "Kardio bra",
      cate: "34,000 MMK",
      img: decoration,
    },
    {
      id: 3,
      name: "Halter Bra",
      cate: "34,000 MMK",
      img: customFurniture,
    },
    {
      id: 4,
      name: "Movement Bra",
      cate: "34,000 MMK",
      img: systemFurniture,
    },
    {
      id: 5,
      name: "Enhance bra",
      cate: "34,000 MMK",
      img: img06,
    },
    {
      id: 6,
      name: "Ace Sports Bra",
      cate: "34,000 MMK",
      img: img07,
    },
  ],
};

export const clientLogos = [
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2F1.png?alt=media&token=4044b031-59dd-40f4-be87-a888bc4aba7a",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2F6d76c8de-29f4-4aa9-adda-b2045a2ae648.png?alt=media&token=8117fecb-b472-4cf2-b7ec-7e7dacd72257",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2FAyeyar-Hinthar-Logo.png?alt=media&token=77275c9f-bece-4f99-87f9-ec0887a34175",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2FIMG_2984.JPG?alt=media&token=16c46ead-1550-4b2e-9589-aec51d51f329",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2FYomaLand_Logo_Solid_BlackText.png?alt=media&token=afa32afb-2896-4603-a507-6d6894cbeeaf",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fawba-group-logo.png?alt=media&token=f8b44b28-ba98-4d8e-925f-618b172f21e6",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fd33de68d-a0e2-4ec4-b051-a5200dccdf4a.png?alt=media&token=a11e281c-a29b-4641-af0e-cc5df8cb9e21",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fdownload.png?alt=media&token=e683e648-a9c9-4e10-8502-a1640799318e",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fimages.jpeg?alt=media&token=35279054-7004-4bc5-8515-53d02aef1498",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fo9SXyF4kPWv_4nhtaCnNLFw--trM-i5Ak3DHW9jTq-SgGZovZQYc0w4IB7bAOg4EZXGELV3ftarKWHZGod8ItBUvBpeHb2B6Q31zu6M_LjjvvS9uD7jvAkxXPDJR3cCErBWqNw_TPOs%3D.jpeg?alt=media&token=e2b241fe-c880-4fef-b147-4c3914e4c1d6",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fo9SXyF4kPWv_4nhtaCnNLFw--trM-i5Aw-7SdA_OtttFa0uPIoPKfiaF1RnZNmC1EFwD-uQDHJFzJhD6VydCLmlgfCqJADVT.png?alt=media&token=8bdb7e5b-2b0b-49c4-a11f-ed90907a1c07",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/urban%2Fclient-logos%2Fog_pioneer_logo.jpg?alt=media&token=7b7ea473-7ec1-42c0-aee1-a0153dc04d22",
  },
];

export const galleryTitles = {
  yoma: "Yoma Land",
  alpha: "Alpha International",
  ige: "IGE Group of Companies",
  sumitomo: "Sumitomo Corporation",
  pioneer: "Pioneer DJ Myanmar",
  reborn: "re : born k beauty & skincare",
  raw: "RAW Coffee Lounge",
  fitbae: "FIT.bae",
  sakura: "Sakura Hospital",
  "city-care": "City Care",
  "city-villa": "City Villa",
  inyamyaing: "InyaMyaing , Bahan",
  "kabaraye-mayangone": "Kabaraye , Mayangone",
  primrose: "Primrose Condo , 8 miles",
  innocity: "Innocity , South Oakkalapa",
  cll: "CLL",
  bahan: "Bahan Residence",
  parami: "Parami Valley Residence",
};
